<div
  class="gallery-preview modal-el"
  (click)="backdropClick($event)"
  data-test-id="attachments-gallery"
>
  <button
    class="nav-arrow nav-prev"
    type="button"
    [disabled]="index === 0"
    (click)="prev($event)"
    data-test-id="attachments-gallery-prev"
    aria-label="Previous"
  >
    <img src="/assets/img/icons/left_arrow.svg" alt="previous" />
  </button>

  <div class="gallery-box modal-info-box">
    <div class="gallery-header">
      <div class="gallery-title" [title]="current?.name">{{ current?.name }}</div>
      <div class="gallery-header-right">
        <!-- ECDEV-431: same actions, same icons as the required documents' preview. -->
        <button
          class="gallery-action"
          type="button"
          title="Download"
          aria-label="Download"
          (click)="download($event)"
          data-test-id="attachments-gallery-download"
        >
          <img src="/assets/img/icons/download_doc.svg" alt="download" />
        </button>
        <button
          class="gallery-action"
          type="button"
          title="Print"
          aria-label="Print"
          (click)="print($event)"
          data-test-id="attachments-gallery-print"
        >
          <img src="/assets/img/icons/print_doc.svg" alt="print" />
        </button>
        <span class="gallery-counter">{{ index + 1 }} / {{ items.length }}</span>
        <img
          class="gallery-close"
          src="/assets/img/icons/close.svg"
          alt="close"
          title="Close"
          (click)="close()"
          data-test-id="attachments-gallery-close"
        />
      </div>
    </div>

    <div class="gallery-content">
      <pdf-viewer
        *ngIf="isPdf; else imageView"
        [src]="pdfSrc!"
        [show-all]="true"
        [render-text]="true"
        [original-size]="false"
        [fit-to-page]="true"
        style="width: 100%; height: 100%"
      ></pdf-viewer>
      <ng-template #imageView>
        <img
          class="gallery-image"
          [src]="imageUrl"
          [alt]="current?.name || 'attachment preview'"
        />
      </ng-template>
    </div>
  </div>

  <button
    class="nav-arrow nav-next"
    type="button"
    [disabled]="index === items.length - 1"
    (click)="next($event)"
    data-test-id="attachments-gallery-next"
    aria-label="Next"
  >
    <img src="/assets/img/icons/right_arrow.svg" alt="next" />
  </button>
</div>
